<template>
  <div class="ms-3">
    <div 
        :class="[outerClass,radioSelected == option.id?'selected':'']"         
        v-for="(option,idx) in optionsAll"
        :key="idx"
        style="position: relative;"
        
    >
      <div
        class="radio radio-custom"
        :class="{disabled: option.disabled}"
        :title="option.disabled?'opcja chwilowo niedostępna':''"
      >
        <label :for="id + '-' + idx" :class="innerClass">
          <div v-if="option.icon" :class="option.icon"></div>
          <input
            :name="id"
            :id="id + '-' + idx"
            type="radio"
            v-model="radioSelected"
            :value="option.id"
            :disabled="option.disabled"

          >
          <span class="radio-custom-btn"></span>
          <span class='option-text' v-html="option.name"></span>
          <span v-if="aria">{{aria}}</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import map from "lodash/map";
import filter from "lodash/filter";
const _ = { map, filter };
export default {
  name: "IcRadioGroup",
  props: {
    id: { type: String, required: true },
    value: { required: true },
    aria: { type: String, required: false },
    options: { type: Array, required: true },
    asObject: { type: Boolean, default: false },
    innerClass: { type: [String, Object], default: "" },
    outerClass: { type: [String, Object], default: "" },
    any: { type: [Boolean], default: false },
    anyName: { type: String, default: "Dowolne" }
  },
  data() {
    return {

      radioSelected: null //checked
    };
  },
  created() {
    this.setData(this.value);
  },
  computed: {
    optionsAll: function() {
      return this.any === true && this.options[0].id !== ""
        ? [{ id: "", name: this.anyName }, ...this.options]
        : this.options;
    }
  },
  watch: {
    value: {
      handler: function(newValue, oldValue) {
        this.setData(newValue);
      },
      deep: true
    },
    radioSelected: function() {
      if (this.asObject) {
        let s = _.filter(this.optionsAll, v => v.id == this.radioSelected);
        this.$emit("input", s[0]);
      } else {
        this.$emit("input", this.radioSelected);
      }
    }
  },
  methods: {
    setData: function(newValue) {
      if (this.asObject) {
        if (newValue.id != this.radioSelected) {
          let s = _.filter(this.optionsAll, v => v.id == newValue.id);
          this.radioSelected = s[0].id;
        }
      } else {
        if (newValue != this.radioSelected) {
          this.radioSelected = newValue;
        }
      }
    }
  }
};
</script>

<style lang="scss">
</style>
